const ActionType = {
  UPDATE: 'UPDATE',
  DUPLICATE: 'DUPLICATE',
  ARCHIVE: 'ARCHIVE',
  UNARCHIVE: 'UNARCHIVE',
  CREATE: 'CREATE',
};

const canPerformAction = (actionType, track) => (
  !!actionType && !!track
);

const isEditAction = (actionType, track) => (
  canPerformAction(actionType, track) && actionType === ActionType.UPDATE
);

const isCreateAction = (actionType) => (
  actionType === ActionType.CREATE
);

const isEditorView = (actionType, track) => (
  isEditAction(actionType, track) || isCreateAction(actionType)
);

export {
  ActionType,
  isEditAction,
  isEditorView,
};
